import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { IStore } from 'Store/.';
import { Dispatch, bindActionCreators } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { OrderPage } from 'Store/Order/enums';
import { fetchClearOrder } from 'Store/Order/thunks';
import { getIsMobile } from 'Store/Screen/selectors';
import {
  clearContent,
  setSelectedSeats,
  appendHoveredSeat,
  clearHoveredSeats,
} from './Redux/actions';
import { setIsManualReservation, setSeatRequests } from 'Store/Order/actions';
import Spinner from 'Components/Shared/Spinner/Spinner';
import ReservationErrors from './ReservationErrors/ReservationErrors';
import PickSeatManually from 'Components/PickSeatManually/PickSeatManually';
import PriceCategoriesList from './PriceCategoriesList/PriceCategoriesList';
import InnerSection from 'Components/PickSeatManually/InnerSection/InnerSection';
import SectionOverview from 'Components/PickSeatManually/SectionOverview/SectionOverview';
import FetchFailureMessage from 'Components/Shared/FetchFailureMessage/FetchFailureMessage';
import FooterButtons from 'Components/PickSeatManually/FooterButtons/FooterButtons';
import SelectedSeatsList from 'Components/PickSeatManually/SelectedSeatsList/SelectedSeatsList';
import SelectedSeat from 'Components/PickSeatManually/SelectedSeatsList/SelectedSeat';

import { 
  fetchSectionOverview, 
  fetchInnerSection, 
  fetchCurrentReservations, 
  fetchNewReservation,
  fetchNewReservations,
  deleteSeatReservation,
  updateSeatDiscount,
  fetchNewReservationsNonNumbered,
} from './Redux/thunks';

import { 
  getIsFetching, 
  getIsFetchFailed, 
  getInnerSection,
  getAlignedSections,
  getPriceCategories,
  getIsReservationSuccessful,
  getReservationErrors,
  getSelectedSeats,
  getHoveredSeats,
  getNbrOfReservationsOnFetch,
  getSeatById,
  getNbrOfRequestedSeats,
  getIsFetchingReservations,
} from 'Components/PickSeatManually/Redux/selectors';
import CategoryDropdown from 'Components/CategoryDropdown/CategoryDropdown';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { Divider } from 'antd';
import NumberInput from 'Components/Shared/NumberInput/NumberInput';
import { getOrderRequest } from 'Store/Order/selectors';
import { FormattedMessage } from 'react-intl';
import Button from 'Components/Shared/Button/Button';

interface IPropsInternal {
  isMobile: boolean;
  isFetching: boolean;
  isFetchFailed: boolean;
  isReservationSuccessful: boolean;
  sections: Julius.Website.SectionViewModel[];
  innerSection: Julius.Website.InnerSectionViewModel;
  selectedSeats: Julius.Website.OrderSeatViewModel[];
  hoveredSeats: Julius.Website.SectionSeatViewModel[];
  priceCategories: Julius.Website.PriceCategoryViewModel[];
  reservationErrors: string[];
  nbrOfReservationsOnFetch: number;
  nbrOfRequestedSeats: number;
  setIsManualReservation: (isManualReservation: boolean) => void;
  fetchCurrentReservations: () => void;
  fetchSectionOverview: (performanceID: number) => void;
  fetchInnerSection: (performanceID: number, innerSectionID: number) => void;
  fetchNewReservation: (seat: Julius.Website.SectionSeatViewModel) => void;
  fetchNewReservations: (seat: Julius.Website.SectionSeatViewModel[]) => void;
  fetchNewReservationsNonNumbered: (performanceID: number, innerSectionId: number, sectionId: number, priceCategoryId: number, discountId: number, numberOfSeats: number) => void;
  deleteSeatReservation: (seats: Julius.Website.OrderSeatViewModel[]) => void;
  updateSeatDiscount: (newSeat: Julius.Website.OrderSeatViewModel) => void;
  clearContent: () => void;
  fetchClearOrder: () => void;
  getSeatById: (seatID: number) => Julius.Website.SectionSeatViewModel;
  appendHoveredSeat: (seats: Julius.Website.SectionSeatViewModel[]) => void;
  setSeatRequests: (seatRequests: Julius.Website.SeatRequestViewModel[]) => void;
  clearHoveredSeats: () => void;
  isFetchingReservations: boolean;
  orderRequest: Julius.Website.OrderRequestViewModel;
};

interface IState {
  isShowingWarningEmpty: boolean;
  isShowingWarningInvalid: boolean;
  isShowingWarningMax10: boolean;
  currentlySelectedDiscountId: number;
  performanceId: number;
  numberOfSeatsInStepper: number;
}

type Props = IPropsInternal & RouteComponentProps<{ orderItemID: string, innerSectionID: string }>;

class PickSeatManuallyContainer extends React.PureComponent<Props, IState> {
  private maxNbrOfSeats: number = 10;

  constructor(props: Props) {
    super(props);

    this.state = {
      isShowingWarningEmpty: false,
      isShowingWarningInvalid: false,
      isShowingWarningMax10: false,
      currentlySelectedDiscountId: 0,
      performanceId: 0,
      numberOfSeatsInStepper: 0,
    }
  }

  componentDidMount() {
    const { params } = this.props.match;
    const orderItemID = parseInt(params.orderItemID, 10);
    this.setState({ performanceId: orderItemID });
    const innerSectionID = parseInt(params.innerSectionID, 10);

    this.props.fetchSectionOverview(orderItemID);
    this.props.fetchInnerSection(orderItemID, innerSectionID);
    this.props.fetchCurrentReservations();
    this.props.setIsManualReservation(true);
  }

  componentWillReceiveProps(nextProps: Props) {
    this.checkIfFetchReservation(nextProps);
    this.checkIfChangedSection(nextProps);
    this.checkIfWarnings(nextProps);
    this.checkIfFetchSeats(nextProps);
  }

  componentWillUnmount() {
    this.props.clearContent();
  }

  checkIfFetchReservation(nextProps: Props) {
    const shouldFetch =
      this.props.nbrOfReservationsOnFetch > 0 &&
      nextProps.nbrOfReservationsOnFetch === 0;

    if (shouldFetch) {
      this.props.fetchCurrentReservations();
    }
  }

  checkIfFetchSeats(nextProps: Props) {
    const shouldFetch = 
      (nextProps.selectedSeats.length < this.props.selectedSeats.length) ||
      (!nextProps.isReservationSuccessful && this.props.isReservationSuccessful);

    if (shouldFetch) {
      const { params } = this.props.match;
      const orderItemID = parseInt(params.orderItemID, 10);
      const innerSectionID = parseInt(params.innerSectionID, 10);
      this.props.fetchInnerSection(orderItemID, innerSectionID);
    }
  }

  checkIfChangedSection = (nextProps: Props) => {
    const { sections, history } = nextProps;
    const nextParams = nextProps.match.params;
    const prevParams = this.props.match.params;

    const nextOrderItemID = parseInt(nextParams.orderItemID, 10);
    const nextInnerSectionID = parseInt(nextParams.innerSectionID, 10);
    const prevInnerSectionID = parseInt(prevParams.innerSectionID, 10);

    if (nextInnerSectionID !== prevInnerSectionID) {
      this.props.fetchInnerSection(nextOrderItemID, nextInnerSectionID);
    }

    if (!nextInnerSectionID && sections) {
      const availableSections = sections.filter(s => s.innerSectionID > 0);

      if (availableSections.length <= 2) {
        history.replace(`/order/${ nextOrderItemID }/platsval/-1`);
      }
    }
  }

  checkIfWarnings = (nextProps: Props) => {
    const nextIsReservationEmpty = nextProps.selectedSeats.length <= 0;
    const nextIsReservationInvalid = nextProps.reservationErrors.length > 0;
    const nextWarningMax10 = nextProps.selectedSeats.length >= 10;
    
    if (
      (this.state.isShowingWarningEmpty && !nextIsReservationEmpty) ||
      (this.state.isShowingWarningInvalid && !nextIsReservationInvalid) ||
      (this.state.isShowingWarningMax10 !== nextWarningMax10)
    ) {
      this.setState({ 
        isShowingWarningEmpty: nextIsReservationEmpty,
        isShowingWarningInvalid: nextIsReservationInvalid, 
        isShowingWarningMax10: nextWarningMax10,
      });
    }
  }

  onSectionClick = (innerSectionID: number) => {
    const { history, match: { params: { orderItemID } } } = this.props;
    history.replace(`/order/${ orderItemID }/platsval/${ innerSectionID }`);
  }

  onSeatClick = (seat: Julius.Website.SectionSeatViewModel) => {
    const { selectedSeats, match: { params } } = this.props;
    const isReservated = selectedSeats.some(s => s.seatID === seat.seatID);

    if (isReservated) {
      this.props.deleteSeatReservation(selectedSeats);
      return;
    }
    
    if (selectedSeats.length >= this.maxNbrOfSeats) {
      return;
    }
    this.props.fetchNewReservations(this.props.hoveredSeats);
  }

  onChangeCategory = (newNumber: number) => {
    this.setState({ numberOfSeatsInStepper: newNumber });
  }

  fetchNonNumberedSeats = (discountId: number, innerSectionId: number, sectionId: number, categoryId: number) => {
    this.props.fetchNewReservationsNonNumbered(this.state.performanceId, innerSectionId, sectionId, categoryId, discountId, this.state.numberOfSeatsInStepper);
    this.setState({ numberOfSeatsInStepper: 0 });
  }

  onSeatHoverEnter = (seat: Julius.Website.SectionSeatViewModel) => {
    const nbrOfRequestedSeats = this.props.nbrOfRequestedSeats || 1;
    const getSeatOnRight = (currentSeat: Julius.Website.SectionSeatViewModel): Julius.Website.SectionSeatViewModel => {
      const seatOnRightID = currentSeat.seatRight;
      const seatOnRight = this.props.getSeatById(seatOnRightID);
      return seatOnRight;
      
    }
    const getSeatOnLeft = (currentSeat: Julius.Website.SectionSeatViewModel): Julius.Website.SectionSeatViewModel => {
      const seatOnLeftID = currentSeat.seatLeft;
      const seatOnLeft = this.props.getSeatById(seatOnLeftID);
      return seatOnLeft;
      
    }
    const isSeatAvailable = (currentSeat: Julius.Website.SectionSeatViewModel): boolean => {
      if (currentSeat.status === 1) {
        return true;
      } else {
        return false;
      }
    }
    const isSeatsToRightAvailable = () => {
      let seatPointer = seat;
      for (let i = 0; i < nbrOfRequestedSeats; i++) {
        if (!seatPointer) {
          return false;
        }
        if (!isSeatAvailable(seatPointer)) {
          return false;
        }
        seatPointer = getSeatOnRight(seatPointer);
      }
      return true;
    }
    const isSeatsToLeftAvailable = () => {
      let seatPointer = seat;
      for (let i = 0; i < nbrOfRequestedSeats; i++) {
        if (!seatPointer) {
          return false;
        }
        if (!isSeatAvailable(seatPointer)) {
          return false;
        }
        seatPointer = getSeatOnLeft(seatPointer);
      }
      return true;
    }
    if (isSeatsToRightAvailable()) {
      let seatPointer = seat;
      const preparedHoveredSeats = [];
      for (let i = 0; i < nbrOfRequestedSeats; i++) {
        preparedHoveredSeats.push(seatPointer);
        seatPointer = getSeatOnRight(seatPointer); 
      }
      this.props.appendHoveredSeat(preparedHoveredSeats);
    } else if(isSeatsToLeftAvailable()) {
      let seatPointer = seat;
      const preparedHoveredSeats = [];
      for (let i = 0; i < nbrOfRequestedSeats; i++) {
        preparedHoveredSeats.push(seatPointer);
        seatPointer = getSeatOnLeft(seatPointer); 
      }
      this.props.appendHoveredSeat(preparedHoveredSeats);
    }
  }

  onSeatHoverLeave = () => {
    this.props.clearHoveredSeats();
  }

  onNext = () => {
    const isReservationEmpty = this.props.selectedSeats.length <= 0 && this.props.orderRequest.seatRequests.length <= 0;
    const isReservationInvalid = this.props.reservationErrors.length > 0;

    if (isReservationEmpty || isReservationInvalid) {
      this.setState({
        isShowingWarningEmpty: isReservationEmpty,
        isShowingWarningInvalid: isReservationInvalid,
      });
    } else {
      this.redirectTo(OrderPage.DETAILS);
    }
  }

  onBack = () => {
    this.redirectTo(OrderPage.START);
  }

  onDiscountChange = (newSeat: Julius.Website.OrderSeatViewModel) => {
    this.props.updateSeatDiscount(newSeat);
  }

  getSeatDiscounts = (seat: Julius.Website.OrderSeatViewModel) => {
    const priceCategory = this.props.priceCategories.find(p => p.id === seat.categoryID);
    return priceCategory ? priceCategory.priceDiscounts : [];
  }

  getSeatDiscountsFromCategoryId = (categoryId: number) => {
    const priceCategory = this.props.priceCategories.find(p => p.id === categoryId);
    return priceCategory ? priceCategory.priceDiscounts : [];
  }

  redirectTo = (page: string) => {
    const { history, match: { params: { orderItemID } } } = this.props;
    history.replace(`/order/${ orderItemID }${ page }`);
  }
  
  render() {
    const { 
      isFetching, 
      isFetchFailed, 
      selectedSeats,
      match: { params: { innerSectionID } },
    } = this.props;

    if (isFetching) {
      return (
        <PickSeatManually>
          <Spinner />
        </PickSeatManually>
      );
    }

    if (isFetchFailed) {
      return (
        <PickSeatManually>
          <FetchFailureMessage />
        </PickSeatManually>
      );
    }

    if (!innerSectionID) {
      return (
        <>
          <PickSeatManually>
            <SectionOverview 
              scale={ 1 }
              isMobile={ this.props.isMobile }
              sections={ this.props.sections }
              onSectionClick={ this.onSectionClick }
            />
          </PickSeatManually>
          <FooterButtons 
            isShowingWarningEmpty={ this.state.isShowingWarningEmpty }
            isShowingWarningInvalid={ this.state.isShowingWarningInvalid }
            onBack={ this.onBack }
            onNext={ this.onNext }
          />
        </>
      );
    }
    else if (this.props.sections
      && this.props.innerSection
      && this.props.sections.find(s => s.innerSectionID.toString() === innerSectionID)
      && !this.props.sections.find(s => s.innerSectionID.toString() === innerSectionID).numberedSeats)
    {
      return (
        <>
          <PickSeatManually>
            <SectionOverview
              scale={ 1 }
              isMobile={ this.props.isMobile }
              sections={ this.props.sections }
              onSectionClick={ this.onSectionClick }
              selectedInnerSection={ parseInt(innerSectionID, 10) }
            />
            <ReservationErrors 
              errors={ this.props.reservationErrors }
              isShowingWarningMax10={ this.state.isShowingWarningMax10 }
              isReservationSuccessful={ this.props.isReservationSuccessful }
            />
          </PickSeatManually>
          <WrapperBox style='selected-seats-list'>
            <FormattedText 
              style='title black'
              displayName={`Välj biljetter - ${ this.props.sections.find(x => x.innerSectionID.toString() === innerSectionID).name }`}
              formattedName='order.tickets.manualSeletHeader'
            />
            {
              this.props.priceCategories.filter(x => this.props.innerSection.seats.some(s => x.id == s.priceCategoryID)).map((pc, i) =>
              <div key={ i } className='seat-items'>
                <div className='seat-item'>
                  <div className='sub-title medium-bold'>
                    { pc.name }
                  </div>
                  <CategoryDropdown 
                    categories={ this.getSeatDiscountsFromCategoryId(pc.id) }
                    selectedCategoryID={ this.state.currentlySelectedDiscountId }
                    onSelect={ (x) => {
                        this.setState({ numberOfSeatsInStepper: 0 });
                        this.setState({ currentlySelectedDiscountId: x });
                      }
                    }
                  />
                  <NumberInput
                    value={ this.state.numberOfSeatsInStepper }
                    isIncrementDisabled={
                      this.state.numberOfSeatsInStepper >= this.props.innerSection.seats.filter(s => pc.id == s.priceCategoryID && s.status === 1).length
                      }
                    onChange={ (newNumber) => this.onChangeCategory(newNumber) }
                  />
                  <Button 
                    onClick={ () => {
                      if (this.state.currentlySelectedDiscountId === 0) {
                        const firstDiscountId = this.getSeatDiscountsFromCategoryId(pc.id)[0].id;
                        this.setState({ currentlySelectedDiscountId: firstDiscountId })
                        this.fetchNonNumberedSeats(firstDiscountId, Number(innerSectionID), this.props.sections.find(x => x.innerSectionID.toString() === innerSectionID).sectionID, pc.id);
                      }
                      else {
                        this.fetchNonNumberedSeats(this.state.currentlySelectedDiscountId, Number(innerSectionID), this.props.sections.find(x => x.innerSectionID.toString() === innerSectionID).sectionID, pc.id);
                      }}}
                    
                  >
                    <FormattedText 
                      displayName='Lägg till biljetter'
                      formattedName='order.tickets.manualSelect.addTicket'
                    />
                  </Button>
                  </div>
                <Divider />
              </div>)
            }
          </WrapperBox>
          <SelectedSeatsList>
            { selectedSeats.map(s =>
              <SelectedSeat
                key={ s.reservationID }
                seat={ s } 
                discounts={ this.getSeatDiscounts(s) } 
                onDiscountChange={ this.onDiscountChange }
                showSeatNumber={ s.isNumberedSeat } />)
            }
          </SelectedSeatsList>
          <FooterButtons 
            isShowingWarningEmpty={ this.state.isShowingWarningEmpty }
            isShowingWarningInvalid={ this.state.isShowingWarningInvalid }
            onBack={ this.onBack }
            onNext={ this.onNext }
          />
        </>
      );
    }

    return (
      <>
        <PickSeatManually>
          <SectionOverview
            scale={ this.props.isMobile ? 1 : 0.5 }
            isMobile={ this.props.isMobile }
            sections={ this.props.sections }
            onSectionClick={ this.onSectionClick }
            selectedInnerSection={ parseInt(innerSectionID, 10) }
          />
          <PriceCategoriesList
            priceCategories={ this.props.priceCategories }
          />
          <InnerSection 
            isMobile={ this.props.isMobile }
            innerSection={ this.props.innerSection }
            selectedSeats={ this.props.selectedSeats }
            hoveredSeats={ this.props.hoveredSeats }
            onSeatClick={ this.onSeatClick }
            onSeatHoverEnter={ this.onSeatHoverEnter }
            onSeatHoverLeave={ this.onSeatHoverLeave }
            priceCategories={ this.props.priceCategories }
            isFetchingReservations={ this.props.isFetchingReservations }
          />
          <ReservationErrors 
            errors={ this.props.reservationErrors }
            isShowingWarningMax10={ this.state.isShowingWarningMax10 }
            isReservationSuccessful={ this.props.isReservationSuccessful }
          />
        </PickSeatManually>
        <SelectedSeatsList>
          { selectedSeats.map(s =>
            <SelectedSeat
              key={ s.reservationID }
              seat={ s } 
              discounts={ this.getSeatDiscounts(s) } 
              onDiscountChange={ this.onDiscountChange }
              showSeatNumber={ s.isNumberedSeat } />)
          }
        </SelectedSeatsList>
        <FooterButtons 
          isShowingWarningEmpty={ this.state.isShowingWarningEmpty }
          isShowingWarningInvalid={ this.state.isShowingWarningInvalid }
          onBack={ this.onBack }
          onNext={ this.onNext }
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    setIsManualReservation,
    fetchCurrentReservations,
    fetchSectionOverview,
    fetchInnerSection,
    fetchNewReservation,
    fetchNewReservations,
    fetchNewReservationsNonNumbered,
    fetchClearOrder,
    deleteSeatReservation,
    updateSeatDiscount,
    setSeatRequests,
    clearContent,
    setSelectedSeats,
    appendHoveredSeat: (seats: Julius.Website.SectionSeatViewModel[]) => appendHoveredSeat(seats),
    clearHoveredSeats,
  }, dispatch);
};

const mapStateToProps = (store: IStore) => {
  return {
    isMobile: getIsMobile(store),
    isFetching: getIsFetching(store),
    isFetchFailed: getIsFetchFailed(store),
    isReservationSuccessful: getIsReservationSuccessful(store),
    nbrOfReservationsOnFetch: getNbrOfReservationsOnFetch(store),
    sections: getAlignedSections(store),
    innerSection: getInnerSection(store),
    reservationErrors: getReservationErrors(store),
    priceCategories: getPriceCategories(store),
    selectedSeats: getSelectedSeats(store),
    hoveredSeats: getHoveredSeats(store),
    orderRequest: getOrderRequest(store),
    nbrOfRequestedSeats: getNbrOfRequestedSeats(store),
    getSeatById: (seatId: number) => getSeatById(store, seatId),
    isFetchingReservations: getIsFetchingReservations(store),
  };
};

export default compose<{}, {}>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(PickSeatManuallyContainer);


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/PickSeatManuallyContainer.tsx